<div class="text-center">
  <img src="/assets/images/connected-accounts/invite-hosts.svg" />
  <h2 style="margin-top: 18px">Invite listing owners to connect</h2>
  <p>
    This connected account is a co-host for some listings on the account. In order for
    {{ 'CORE.PRODUCT_NAME' | transloco }} to function for those listings, you need to invite the owner of the listing to
    connect their account to {{ 'CORE.PRODUCT_NAME' | transloco }}.
  </p>

  <div *ngIf="listings.length > 0" style="margin-top: 24px">
    <div *ngFor="let listing of listings" class="listing" fxLayoutAlign="start center" fxLayoutGap="12px">
      <img width="30" height="20" [src]="listing.picture" />
      <span>{{ listing.name }}</span>
    </div>
  </div>

  <div fxLayoutAlign="end center" style="margin-top: 24px">
    <sbnb-button (click)="invite()" style="margin-top: 32px" label="Invite listing owners"></sbnb-button>
  </div>
</div>
